import { createFileRoute, Link } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";

export const Route = createFileRoute("/admin/")({
  component: AdminDashboard,
});

function AdminDashboard() {
  return (
    <ProtectedRoute requiredPermissions={["Users.Read"]} requiredRoles={["Admin"]}>
      <AdminPageLayout>
        <div className="mx-auto max-w-5xl p-6">
          <h1 className="text-2xl font-bold">Admin</h1>
          <p className="text-sm text-gray-600">Administrative tools and controls</p>

          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <Link
              to="/admin/courses"
              className="border-arc-base-black hover:bg-arc-gray-50 block rounded-lg border-2 p-4 transition-colors"
            >
              <div className="text-lg font-semibold">Course Management</div>
              <div className="text-sm text-gray-600">
                Review catalogue, publishing status, and create new courses
              </div>
            </Link>
            <Link
              to="/admin/users"
              className="border-arc-base-black hover:bg-arc-gray-50 block rounded-lg border-2 p-4 transition-colors"
            >
              <div className="text-lg font-semibold">User Management</div>
              <div className="text-sm text-gray-600">
                View users, inspect roles, and manage assignments
              </div>
            </Link>
            <Link
              to="/admin/roles"
              className="border-arc-base-black hover:bg-arc-gray-50 block rounded-lg border-2 p-4 transition-colors"
            >
              <div className="text-lg font-semibold">Roles & Permissions</div>
              <div className="text-sm text-gray-600">View roles and adjust permissions</div>
            </Link>
          </div>
        </div>
      </AdminPageLayout>
    </ProtectedRoute>
  );
}
